import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  clearAll,
  onGetAdditionalDocuments,
  onRequestBalance,
  showCertificateFormFunc,
  showRequestBalanceFunc,
} from "../../../../config/redux/slice/transfereeUserSlice";
import { useDispatch, useSelector } from "react-redux";
import { appApi } from "../../../../utils/endpoints/appApi";
import { getRequest, postRequest } from "../../../../helpers/request";
import {
  onAddCertificate,
  setErrorMessageTransfereeUser,
  setLoadingTransfereeUser,
} from "../../../../config/redux/slice/transfereeUserSlice";
import { Spinner } from "../../../components";
import {
  formatNumber,
  getCurrencySymbol,
  truncateMiddle,
} from "../../../../helpers/helpers";
import moment from "moment";
import {
  onGetBanks,
  setIsRefreshed,
} from "../../../../config/redux/slice/appSlice";

export default function BalanceRequestForm() {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setError,
    setValue,
    formState: { errors },
    reset,
  } = useForm({ mode: "onTouched" });
  // const [amount_requested, setRealAmountReq] = useState("")
  //  const [amount_available, setRealAmountAvail] = useState("")
  const [whtRates, setWhtRates] = useState([]);
  const { currencies, banks } = useSelector((state) => state.app);
  const {
    transfereeUserLoading,
    transfereeUserErrorMsg,
    certificateManagement: {
      certificatesData,
      certificateDetails,
      newData,
      showCertificateForm,
    },
  } = useSelector((state) => state.transfereeUser);

  const { token } = useSelector((state) => state.authData);

  // const [currencies, setCurrencies] = useState([])
  const [formData, setFormData] = useState(new FormData());
  const [documents, setDocuments] = useState([]);
  const [file_names, setFileNames] = useState([]);
  const [bankMismatchError, setBankMismatchError] = useState("");
  const [isValidatingBankRep, setIsValidatingBankRep] = useState(false);

  const validateBankRep = async (email, bankId) => {
    if (!email || !bankId) {
      setBankMismatchError("");
      return true;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return true;
    }

    setIsValidatingBankRep(true);
    try {
      const res = await postRequest(
        token,
        `${appApi.validateBankRep}`,
        { contact_email: email, bank_id: bankId },
        dispatch,
        "",
        "",
        "",
      );

      if (res && res.status >= 400) {
        const msg =
          res.data?.message ||
          "The selected bank does not match the bank representative's registered bank.";
        setBankMismatchError(msg);
        return false;
      } else {
        setBankMismatchError("");
        return true;
      }
    } catch (err) {
      return true;
    } finally {
      setIsValidatingBankRep(false);
    }
  };

  useEffect(() => {
    getBanks();
    getAdditionalDocs();
  }, []);

  const closeModal = () => {
    dispatch(clearAll({}));
    dispatch(showRequestBalanceFunc({ modal: false }));
  };

  const getBanks = async () => {
    const res = await getRequest(
      token,
      `${appApi.banks}`,
      {},
      dispatch,
      "",
      onGetBanks,
      "",
    );
  };

  const getAdditionalDocs = async () => {
    const res = await getRequest(
      token,
      `${appApi.getAdditionalDocuments(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      onGetAdditionalDocuments,
      "",
    );
    if (res != undefined && res.status < 400) {
      for (let singleItem of res.data.data) {
        setFileNames((prev) => [...prev, singleItem.FILE_NAME]);
        setDocuments((prev) => [...prev, singleItem.FILE_URL]);
      }
      setFileNames((prev) => Array.from(new Set(prev)));
      setDocuments((prev) => Array.from(new Set(prev)));
    }
  };

  const formatAmount = (value) => {
    if (!value) return "";

    // Remove everything except digits
    const numericValue = String(value).replace(/\D/g, "");

    if (!numericValue) return "";

    // Format ONLY commas
    return Number(numericValue).toLocaleString("en-US");
  };

  // const convertToNumber = (stringValue) => {
  //   let originalValue = stringValue.replace(",", "");
  //   originalValue = originalValue.replace(".00", "");
  //   return originalValue;
  // };

  const convertToNumber = (value) => {
    if (!value) return 0;

    return Number(String(value).replace(/,/g, ""));
  };

  const onSubmit = async (data) => {
    dispatch(clearAll({}));

    if (data.contact_email && data.bank_id) {
      const isValidRep = await validateBankRep(data.contact_email, data.bank_id);
      if (!isValidRep) {
        return;
      }
    }

    let amount_requested = convertToNumber(data.amount_requested_temp);
    let fileNames = file_names.join(",");
    data = {
      ...data,
      issuer: "NOTAP",
      certificate_id: certificateDetails?.ID,
      certificate_number: certificateDetails?.CERTIFICATE_NUMBER,
      certificate_date: certificateDetails?.CERTIFICATE_DATE,
      amount_requested,
      currency: certificateDetails?.CURRENCY,
      // wht_id: certificateDetails?.WHT_ID,
      // wht_percentage: certificateDetails?.WHT_RATE_PERCENTAGE,
      certificate_letter_url: certificateDetails?.CERTIFICATE_FILE_PATH,
      // original_amount_req: (certificateDetails?.ORIGINAL_AMOUNT_REQUESTED - (certificateDetails?.ORIGINAL_AMOUNT_REQUESTED * (certificateDetails?.WHT_RATE_PERCENTAGE / 100)))
      original_amount_req: certificateDetails?.ORIGINAL_AMOUNT_REQUESTED,
      amount_on_certificate: certificateDetails?.AMOUNT_ON_CERTIFICATE,
      effective_date: certificateDetails?.EFFECTIVE_DATE,
      expiry_date: certificateDetails?.EXPIRY_DATE,
      certificate_number_two: certificateDetails?.CERTIFICATE_NUMBER_TWO,
      cover_letter: certificateDetails?.COVER_LETTER,
      stamped_agreement: certificateDetails?.STAMPED_AGREEMENT,
      // invoice: certificateDetails?.INVOICE,
      certificate_file: certificateDetails?.CERTIFICATE_FILE_PATH,
      certificate_balance: certificateDetails?.CERTIFICATE_BALANCE,
      documents,
      file_names: fileNames,
    };
    const res = await postRequest(
      token,
      `${appApi.requestBalance}`,
      data,
      dispatch,
      setLoadingTransfereeUser,
      "",
      setErrorMessageTransfereeUser,
    );
    if (res != undefined && res.status < 400) {
      dispatch(onRequestBalance({ message: res.data.message }));
      dispatch(setIsRefreshed());
    }
  };

  useEffect(() => {
    if (certificateDetails?.EFFECTIVE_DATE) {
      setValue(
        "effective_date",
        moment(certificateDetails.EFFECTIVE_DATE).format("YYYY-MM-DD"),
        { shouldValidate: false },
      );
    }
  }, [certificateDetails, setValue]);

  const resetFormPreservingDates = () => {
    setBankMismatchError("");
    reset({
      amount_requested_temp: "",
      bank_id: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      comment: "",
    });
  };

  function addFileName(e, idValue) {
    let fileName = e.target.value;
    if (fileName !== "") {
      fileName = fileName.replace(/^.*[\\/]/, "");
      document.getElementById(idValue).innerHTML = truncateMiddle(fileName, 30);
    } else {
      document.getElementById(idValue).innerHTML = "No file Chosen";
    }
  }
  function getFormattedBalance(amountApproved, amountDisbursed) {
    let balance = amountApproved - amountDisbursed;
    return formatNumber(balance);
  }

  return (
    <div
      className="modal fade show"
      id="basicModal"
      tabIndex="-1"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.3)",
        overflowY: "auto",
      }}
    >
      <div
        style={{ overflowY: "auto" }}
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <form
            onSubmit={handleSubmit(onSubmit)}
            autoComplete={"off"}
            noValidate
          >
            <div className="modal-header px-4">
              <h6 className="modal-title" id="exampleModalCenterTitle">
                Balance Request
              </h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  closeModal();
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body px-4 px-md-7">
              <div>
                <h6 className="mb-3 font-weight-bold">
                  Certificate Information
                </h6>
                <div className="row mb-2">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="certificate_number">
                        Reference ID (File No)
                      </label>
                      <input
                        defaultValue={certificateDetails?.CERTIFICATE_NUMBER}
                        disabled
                        type="text"
                        className="form-control input-lg"
                        id="certificate_number"
                        {...register("certificate_number")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="certificate_number_two">
                        Certificate Number
                      </label>
                      <input
                        defaultValue={
                          certificateDetails?.CERTIFICATE_NUMBER_TWO
                        }
                        disabled
                        type="text"
                        className="form-control input-lg"
                        id="certificate_number_two"
                        {...register("certificate_number_two")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="certificate_date">
                        Certificate Issue Date
                      </label>
                      <input
                        type="date"
                        disabled
                        defaultValue={certificateDetails?.CERTIFICATE_DATE}
                        className="form-control input-lg"
                        id="certificate_date"
                        {...register("certificate_date")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="expiry_date">
                        Certificate Expiry Date
                      </label>
                      <input
                        type="date"
                        disabled
                        defaultValue={certificateDetails?.EXPIRY_DATE}
                        className="form-control input-lg"
                        id="expiry_date"
                        {...register("expiry_date")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="effective_date">
                        Certificate Effective Date
                      </label>
                      <input
                        type="date"
                        disabled
                        // defaultValue={certificateDetails?.EFFECTIVE_DATE}
                        className="form-control input-lg"
                        id="effective_date"
                        {...register("effective_date")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="currency">Currency</label>
                      <input
                        type="text"
                        defaultValue={certificateDetails?.CURRENCY}
                        className="form-control input-lg"
                        id="currency"
                        disabled
                        {...register("currency")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="balance_temp">Balance</label>
                      <input
                        defaultValue={formatNumber(
                          certificateDetails?.CERTIFICATE_BALANCE,
                        )}
                        type="text"
                        className="form-control input-lg"
                        id="balance_temp"
                        {...register("balance_temp")}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="amount_requested_temp">
                        Amount Requested
                      </label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="amount_requested_temp"
                        {...register("amount_requested_temp", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          validate: (value) =>
                            Number(convertToNumber(value)) <=
                              Number(certificateDetails?.CERTIFICATE_BALANCE) ||
                            "Amount greater than amount requested",
                          // pattern: {
                          //   value: /^[1-9]\d*$/i,
                          //   message: '*invalid input'
                          // }
                        })}
                        onChange={(e) => {
                          const formattedValue = formatAmount(e.target.value);

                          setValue("amount_requested_temp", formattedValue, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {errors?.amount_requested_temp?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.amount_requested_temp?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div className='col-lg-6'>
                <div className="form-group">
                    <label htmlFor='wht_rate'>W.H.T Rate</label>
                    <select 
                    disabled
                      className="form-control rounded-0" 
                      id="wht_rate"
                      value={`${certificateDetails?.WHT_ID},${certificateDetails?.WHT_RATE_PERCENTAGE}`}
                      {...register("wht_rate")
                      } 
                    >
                      <option value={''}>Select rate</option>
                      {whtRates.map((rate, i)=>{
                        return <option key={i} value={`${rate.id},${rate.percentage}`}>{rate.name}</option>
                      })}
                    </select>
                  </div>
              </div> */}
                </div>
              </div>

              <div>
                <h6 className="mb-3 font-weight-bold">Bank Information</h6>
                <div className="row mb-2">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="bank_id">Select your Bank</label>
                      <select
                        className={`form-control rounded-0 ${bankMismatchError ? "is-invalid border-danger" : ""}`}
                        id="bank_id"
                        {...register("bank_id", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          onChange: (e) => {
                            const email = watch("contact_email");
                            validateBankRep(email, e.target.value);
                          },
                        })}
                      >
                        <option value={""}>Select Bank</option>
                        {banks.map((bank) => {
                          return (
                            <option key={bank.ID} value={bank.ID}>
                              {bank.BANK_NAME}
                            </option>
                          );
                        })}
                      </select>
                      {errors?.bank_id?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.bank_id?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="contact_name">Contact Name</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="contact_name"
                        {...register("contact_name", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                        })}
                      />
                      {errors?.contact_name?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.contact_name?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="contact_email">Contact Email</label>
                      <input
                        type="text"
                        className={`form-control input-lg ${bankMismatchError ? "is-invalid border-danger" : ""}`}
                        id="contact_email"
                        {...register("contact_email", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "*invalid email pattern",
                          },
                          onBlur: (e) => {
                            const bankId = watch("bank_id");
                            validateBankRep(e.target.value, bankId);
                          },
                        })}
                      />
                      {isValidatingBankRep && (
                        <div className="text-muted small mt-1">
                          <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                          Verifying bank representative...
                        </div>
                      )}
                      {errors?.contact_email?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.contact_email?.message}
                        </div>
                      )}
                      {!errors?.contact_email?.message && bankMismatchError && (
                        <div className="text-danger small mt-1 font-weight-bold">
                          {bankMismatchError}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="contact_phone">
                        Contact Phone Number
                      </label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="contact_phone"
                        {...register("contact_phone", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          pattern: {
                            value: /^0\d{10}$/i,
                            message: "*invalid phone number pattern",
                          },
                        })}
                      />
                      {errors?.contact_phone?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.contact_phone?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* <div>
            <h6 className='mb-3 font-weight-bold'>Certificate Upload</h6> */}
              {/* </div> */}

              <div className="form-group">
                <label htmlFor="comment">Comment</label>
                <textarea
                  style={{ resize: "none" }}
                  className="form-control"
                  id="comment"
                  rows="4"
                  {...register("comment")}
                ></textarea>
              </div>
            </div>
            <div className="modal-footer px-4 d-flex align-items-center">
              <button
                disabled={transfereeUserLoading ? true : false}
                onClick={resetFormPreservingDates}
                type="button"
                className="btn btn-smoke"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <div>
                {transfereeUserLoading ? (
                  <Spinner />
                ) : (
                  <button type="submit" className="btn btn-primary">
                    Send link to bank contact
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
